/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { environmentsCreate } from "../funcs/environmentsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Environment } from "../models/components/environment.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateEnvironmentRequest,
  CreateEnvironmentSecurity,
} from "../models/operations/createenvironment.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateEnvironmentMutationVariables = {
  request: CreateEnvironmentRequest;
  security?: CreateEnvironmentSecurity | undefined;
  options?: RequestOptions;
};

export type CreateEnvironmentMutationData = Environment;

export type CreateEnvironmentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createEnvironment environments
 *
 * @remarks
 * Create a new environment
 */
export function useCreateEnvironmentMutation(
  options?: MutationHookOptions<
    CreateEnvironmentMutationData,
    CreateEnvironmentMutationError,
    CreateEnvironmentMutationVariables
  >,
): UseMutationResult<
  CreateEnvironmentMutationData,
  CreateEnvironmentMutationError,
  CreateEnvironmentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateEnvironmentMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateEnvironment(): MutationKey {
  return ["@gram/client", "environments", "create"];
}

export function buildCreateEnvironmentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateEnvironmentMutationVariables,
  ) => Promise<CreateEnvironmentMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateEnvironment(),
    mutationFn: function createEnvironmentMutationFn({
      request,
      security,
      options,
    }): Promise<CreateEnvironmentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(environmentsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
